import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

import { devSearchSchemaFor } from "@/modules/dev/registry/previews";

export const Route = createFileRoute("/dev/survey-flow")({
  validateSearch: devSearchSchemaFor("survey-flow"),
  component: lazyRouteComponent(
    () => import("@/modules/session-survey/dev/SurveyFlowPreview"),
    "SurveyFlowPreview",
  ),
});
